module.exports = __webpack_public_path__ + "static/media/vedett-blond.4b6ea69a.jpg";